/**
 * utils/axios.js
 * For calling it with utils function
 **/
import axios from 'axios'
export default axios
